// Images live here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview
export default {
  content: {
    heading: 'press',
    subheading: 'Read what the world is saying about MikMak',
    list: [
      {
        name: 'inc',
        url: 'https://www.inc.com/magazine/201810/inc-staff/morgan-debaun-and-other-problem-solvers-female-founders-100.html'
      },
      {
        name: 'techcrunch',
        url: 'https://techcrunch.com/2017/04/25/mikmak-is-using-mini-infomercials-to-help-retailers-turn-their-stories-into-sales/'
      },
      {
        name: 'digiday',
        url: 'https://digiday.com/marketing/brands-testing-shoppable-videos-instagram-stories-snap-ads/'
      },
      {
        name: 'adweek',
        url: 'https://www.adweek.com/digital/the-company-thats-taking-shoppable-video-seriously-and-driving-results/'
      },
      // {
      //   name: 'forbes',
      //   url: 'https://www.forbes.com/sites/jenniferrooney/2015/05/13/with-mikmak-forbes-30-under-30-alum-tipograph-reinvents-the-infomercial/#296fb0a327ea'
      // },
      {
        name: 'cheddar',
        url: 'https://cheddar.com/videos/rachel-tipograph-founder-mikmak'
      },
      // {
      //   name: 'psfk',
      //   url: 'https://www.psfk.com/2017/04/mikmak-lets-brands-sell.html'
      // },
      {
        name: 'fast-company',
        url: 'https://www.fastcompany.com/3046202/this-is-how-you-make-infomericals-millenials-will-watch '
      },
      {
        name: 'entrepreneur',
        url: 'https://www.entrepreneur.com/slideshow/303904/#42'
      },
      {
        name: 'bloomberg',
        url: 'https://www.youtube.com/watch?v=1KqP2RIcCoc&feature=youtu.be&t=38m5s'
      },
      {
        name: 'adlandia',
        url: 'https://podcasts.apple.com/us/podcast/adlandia/id1207451238?i=1000394814856&mt=2'
      },
      // {
      //   name: 'internet-retailer',
      //   url: 'https://www.instagram.com/p/BcmzM_Dgyec/'
      // },
      {
        name: 'interbrand',
        url: 'http://interbrand.com/best-brands/interbrand-breakthrough-brands/2017/articles/5-questions-mikmak/'
      },
      {
        name: 'marieclaire',
        url: 'https://www.marieclaire.com/culture/g3230/the-new-guard-influential-women/'
      },
      {
        name: 'wall-street-journal',
        url: 'https://www.wsj.com/articles/meet-mikmak-the-mobile-shopping-network-that-sells-via-video-1467832496'
      },
      // {
      //   name: 'mediapost',
      //   url: 'https://www.mediapost.com/publications/article/304450/burger-kings-machado-ges-comstock-among-ad-club.html'
      // },
      {
        name: 'emarketer',
        url: 'https://drive.google.com/file/d/0BzqJZaqgqjeqdFR4VHU2VFlObnhYanhvclFxcWNMQVF0eEpN/view'
      },
      {
        name: 'business-of-fashion',
        url: 'https://drive.google.com/file/d/0BzqJZaqgqjeqWHV3NkNEemh4RFN4VnZyakpVX2dYZG1wVGtZ/view'
      }
      // {
      //   name: 'ad-age',
      //   url: 'http://adage.com/article/cmo-strategy/infomercial-iphone-generation/298637/'
      // },
      // {
      //   name: 'fox-news',
      //   url: 'https://thenextweb.com/apps/2015/06/04/dothemikmak/#.tnw_5mBWv1fu'
      // },
      // {
      //   name: 'glamour',
      //   url: 'http://www.glamour.com/story/shopping-app-store-apple'
      // },
      // {
      //   name: 'the-next-web',
      //   url: 'https://thenextweb.com/apps/2015/06/04/dothemikmak/#.tnw_5mBWv1fu'
      // },
      // {
      //   name: 'vanity-fair',
      //   url: 'http://www.vanityfair.com/style/2015/09/so-heres-donald-drawbertson-robertsons-story-with-smashbox-cosmetics-and-friends-during-nyfw'
      // },
      // {
      //   name: 'wwd',
      //   url: 'http://wwd.com/business-news/marketing-promotion/mikmak-infomercials-for-millennials-10253483/'
      // }
    ]
  }
}



// WEBPACK FOOTER //
// ./client/store/imports/Press.js